import { Vector3 as t, Quaternion as c } from "three";
import { QuaternionToDegrees as a } from "./index19.js";
const o = new t(), r = new c(), m = new t();
function u(n) {
  n.decompose(o, r, m);
  const e = o.toArray(), s = a(r);
  return { pos: e, rot: s };
}
export {
  u as matrixToRgTransform
};
//# sourceMappingURL=index16.js.map
